import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { useLanguage } from "@/contexts/LanguageContext";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SignupPage = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSignup = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error(t("auth_password_mismatch"));
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(`${API}/auth/register-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        const user = await response.json();
        toast.success(t("common_success"));
        navigate("/dashboard", { state: { user } });
      } else {
        const error = await response.json();
        toast.error(error.detail || t("common_error"));
      }
    } catch (error) {
      console.error("Signup error:", error);
      toast.error(t("common_error"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper px-4">
      <Card className="w-full max-w-md p-6 space-y-6">
        <div className="text-center space-y-2">
          <h1 className="font-heading text-2xl font-semibold text-stone-900">
            {t("auth_signup_title")}
          </h1>
          <p className="text-stone-600 text-sm">
            {t("auth_signup_subtitle")}
          </p>
        </div>

        <form onSubmit={handleSignup} className="space-y-4">
          <div className="space-y-1">
            <label className="text-sm font-medium text-stone-700">
              {t("auth_email")}
            </label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="space-y-1">
            <label className="text-sm font-medium text-stone-700">
              {t("auth_password")}
            </label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="space-y-1">
            <label className="text-sm font-medium text-stone-700">
              {t("auth_confirm_password")}
            </label>
            <Input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <Button
            type="submit"
            className="w-full btn-primary"
            disabled={isLoading}
          >
            {isLoading ? t("common_loading") : t("auth_signup_button")}
          </Button>
        </form>

        <p className="text-center text-sm text-stone-500">
          {t("auth_have_account")} {" "}
          <Link to="/login" className="text-primary font-medium">
            {t("auth_login_link")}
          </Link>
        </p>
      </Card>
    </div>
  );
};

export default SignupPage;
